import axios from "@/services/axios";
import { TagsDetails } from "@/models/tags";

class TagsService {
  private readonly BASE_URL = "/api/account-management/tags";

  getAllTags(filter: string = ""): Promise<any> {
    const params: any = {
      size: 100,
    };
    if (filter) {
      params["filter"] = filter;
    }
    return axios.get(`${this.BASE_URL}`, { params });
  }

  getTags(
    pageIndex: number,
    pageSize: number,
    sortField?: string,
    sortOrder?: string,
  ) {
    const dir =
      sortOrder === "descend" ? sortField + ",DESC" : sortField + ",ASC";
    const sort = sortField && sortOrder != "none" ? dir : "";

    let param: any = {
      page: pageIndex,
      size: pageSize,
      sort,
    };
    return axios.get(`${this.BASE_URL}`, {
      params: param,
    });
  }

  getTagAccess(
    pageIndex: number,
    pageSize: number,
    searchText?: string,
    sortField?: string,
    sortOrder?: string,
  ) {
    const dir =
      sortOrder === "descend" ? sortField + ",DESC" : sortField + ",ASC";
    const sort = sortField && sortOrder != "none" ? dir : "";

    let param: any = {
      page: pageIndex,
      size: pageSize,
      sort,
    };
    if (searchText) {
      param["filter"] = searchText;
    }
    return axios.get(`/api/account-management/tags/organisation`, {
      params: param,
    });
  }

  assignUser(userData: any, tagId: string): Promise<any> {
    return axios.put(
      `/api/account-management/tags/organisation/${tagId}/access`,
      userData,
    );
  }

  createTag(tag: TagsDetails): Promise<any> {
    return axios.post(`${this.BASE_URL}`, tag);
  }

  deleteTag(tagId: number): Promise<number> {
    return axios.delete(`${this.BASE_URL}/${tagId}`);
  }
}
export const tagsService = new TagsService();
